import { min, required, SchemaPathTree, max, debounce, FieldTree } from '@angular/forms/signals';
import { VoltageDropPointDto } from '../../../core/mceapi.client.generated';
import { signal } from '@angular/core';


export interface VoltageDrop {
  maximumVoltageDrop: number; // percentage
}

export function buildVoltageDropSchema(path: SchemaPathTree<VoltageDrop>) {
  required(path.maximumVoltageDrop, { message: `Maximum voltage drop is required` });
  min(path.maximumVoltageDrop, 0, { message: `Maximum voltage drop must be positive` });
  max(path.maximumVoltageDrop, 100, { message: `Maximum voltage drop cannot exceed 100%` });
  debounce(path.maximumVoltageDrop, 500);
}

export function createVoltageDrop(dto: VoltageDropPointDto) {
  if (dto.maximum === undefined) {
    throw new Error('Voltage drop DTO is missing its maximum value.');
  }

  return signal<VoltageDrop>({ maximumVoltageDrop: (dto.maximum * 100).roundTo(9) });  // convert from point to percentage
}

export function createVoltageDropDto(model: FieldTree<VoltageDrop>) {
  return signal<VoltageDropPointDto>({ maximum: model.maximumVoltageDrop().value() / 100 });  // convert from percentage to point
}
